import React from 'react';
import './WhyRecruitAI.scss';

const WhyRecruitAI = () => {
  return (
    <section className="why-recruit section">
      <div className="container">
        <h2 className="why-recruit__title">
          WHY RECRUIT AN AI VIRTUAL ASSISTANT?
        </h2>
        <div className="why-recruit__content">
          <p className="why-recruit__text">
            Traditional support models, such as call center-based systems, are outdated, slow, and expensive. Customers often struggle to get the help they need, leading to lower satisfaction, higher customer churn, and spiraling expenses.
          </p>
          <p className="why-recruit__text">
            Skil Inc's AI-powered chatbot virtual assistants use conversational AI to provide virtual assistance to businesses and customers. Our chatbot solutions can seamlessly link up with your existing IT systems to create a unified AI platform that streamlines all of your communications and offers helpful, intuitive functionality for users. AI chatbot platforms are the future of support. Recruit an AI-based chatbot to start automating and simplifying your business now.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyRecruitAI; 
